
import React, { Component } from "react";
import OurLeadsContent from "../function-components/OurLeads/OurLeadsContent";

class OurLeads extends Component {
  render() {
    return (
      <>
        <OurLeadsContent />
      </>
    );
  }
}

export default OurLeads;
